// File: LLPAnnualCompliance.jsx
import React from "react";

export default function LLPAnnualCompliance() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            LLP Annual Compliance
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks manages LLP annual filings to ensure MCA compliance.
          </p>
          <p className="text-gray-700">
            Complete annual compliance including Form 8 (Statement of Account & Solvency), Form 11 (Annual Return), Form AOC-4, statutory audit coordination, Designated Partner Identification Number (DPIN) updates, and MCA penalty avoidance.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: LLP compliance MCA filings India) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/669615/pexels-photo-669615.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="LLP Annual Compliance MCA filings India"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless MCA LLP compliance approvals.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>LLP Agreement and amendments</li>
                <li>Financial statements (Balance Sheet, P&L)</li>
                <li>Partner/Designated Partner details (Form 4)</li>
                <li>Bank statements and audit reports</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Timely filings, penalty avoidance, professional handling of LLP annual MCA compliance requirements.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Timely MCA Filings
                </h3>
                <p className="text-gray-700 text-sm">
                  Form 11 (Annual Return) within 60 days of 31st March, Form 8 (Statement of Account & Solvency) within 30 days of 6 months from FY end, Form AOC-4 financials, ensuring zero MCA late filing penalties and active LLP status maintenance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Penalty Avoidance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete compliance calendar management, statutory audit coordination with CA, Designated Partner changes (Form 4), LLP Agreement amendments (Form 3), event-based filings, and MCA master data accuracy preventing ₹100-₹5 lakhs penalties.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Compliance Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Full-service LLP compliance including DIR-3 KYC, DPIN updates, statutory registers maintenance, board resolutions, ROC inspection readiness, strike-off avoidance, conversion advisory, and ongoing MCA compliance monitoring with Hawkins & Brooks expertise.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
